module.exports = {
  label: {
    heading: 'Masai Shikas',
    wear: 'Women’s Wear',
    product: 'Sweaters',
    code: 'MT-216-213',
    priceSymbol: 'KES',
    available: 'Available in 30 variants',
    shortDesc: {
      title: 'Short Description',
      content: 'Women’s light weight V-neck cardigan.',
    },
    longDesc: {
      title: 'Long Description',
      content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    },
    material: {
      title: 'Material',
      content: '100% Acrylic',
    },
    getInspired: {
      title: 'Get Inspired',
      content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      explore: 'Explore'
    },
    specs: {
      title: 'Specs',
      table: {
        specsTable: [
          {
            "Size": "1/2 Chest",
            "90": "25 1/2",
            "100": '25 1/2',
            "110": "25 1/2",
            "120": '25 1/2',
            "130": "25 1/2",
            "140": '25 1/2',
            "150": "25 1/2"
          },
          {
            "Size": "1/2 Bottom",
            "90": "27",
            "100": '28',
            "110": "29",
            "120": '30',
            "130": "31",
            "140": '32',
            "150": "33"
          },
          {
            "Size": "Shoulder",
            "90": "27",
            "100": '28',
            "110": "29",
            "120": '30',
            "130": "31",
            "140": '32',
            "150": "33"
          },
          {
            "Size": "Body Length",
            "90": "27",
            "100": '28',
            "110": "29",
            "120": '30',
            "130": "31",
            "140": '32',
            "150": "33"
          },
          {
            "Size": "Sleeve Length",
            "90": "27",
            "100": '28',
            "110": "29",
            "120": '30',
            "130": "31",
            "140": '32',
            "150": "33"
          }
        ]
      }
    },
    careInstructions: {
      title: 'Care Instructions',
    },
  },
}